import React from "react";

const Footer = () => (
  <footer style={{
    background: "transparent",          // transparent background
    padding: "2rem 1rem",
    textAlign: "center",
    color: "rgba(255,255,255,0.6)",
    fontSize: "0.9rem",
    borderTop: "none"                   // remove top border line
  }}>
    © {new Date().getFullYear()} Digital Ladyland. All rights reserved.
  </footer>
);

export default Footer;
